import { render, staticRenderFns } from "./BackIndex.vue?vue&type=template&id=2ec7dacb&scoped=true"
import script from "./BackIndex.vue?vue&type=script&lang=js"
export * from "./BackIndex.vue?vue&type=script&lang=js"
import style0 from "./BackIndex.vue?vue&type=style&index=0&id=2ec7dacb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7dacb",
  null
  
)

export default component.exports